/* PDP hero — HELP-16306 Ticket 01 (gallery) + Ticket 02 (buy-box states) + Ticket 03 (plan
   availability, selected-plan sync and the atomic device + plan add-to-cart, G22). */
(function () {
  'use strict';

  function initGallery(gallery) {
    var slides = Array.prototype.slice.call(gallery.querySelectorAll('.pdp-hero__gallery-slide'));
    var strip = gallery.querySelector('.pdp-hero__thumbs');
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('.pdp-hero__thumb'));
    var prevBtn = gallery.querySelector('.pdp-hero__chevron--prev');
    var nextBtn = gallery.querySelector('.pdp-hero__chevron--next');
    var index = 0;

    if (gallery.classList.contains('pdp-hero__gallery--zoom')) initZoom(gallery, slides);

    if (slides.length <= 1) return;

    function render() {
      slides.forEach(function (slide, i) {
        slide.hidden = i !== index;
      });
      thumbs.forEach(function (thumb, i) {
        var isActive = i === index;
        thumb.classList.toggle('is-active', isActive);
        thumb.setAttribute('aria-current', isActive ? 'true' : 'false');
        if (isActive && strip) {
          /* Keep the active thumb visible inside the scrolling strip (G73). Only the strip's own
             scrollLeft moves — never the page. */
          var target = thumb.offsetLeft - (strip.clientWidth - thumb.offsetWidth) / 2;
          strip.scrollLeft = Math.max(0, target);
        }
      });
      if (prevBtn) prevBtn.disabled = index === 0;
      if (nextBtn) nextBtn.disabled = index === slides.length - 1;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        if (index === 0) return;
        index -= 1;
        render();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        if (index === slides.length - 1) return;
        index += 1;
        render();
      });
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        index = i;
        render();
      });
    });

    render();
  }

  /* Roving tabindex for a radiogroup of buttons: only the checked radio is in the tab order,
     arrow keys move the selection and skip radios `canSelect` rejects. `onSelect(radio)` applies
     the group's own state change. */
  function initRadioGroup(radios, onSelect, canSelect) {
    var keys = { ArrowLeft: -1, ArrowUp: -1, ArrowRight: 1, ArrowDown: 1 };

    function selectable(radio) {
      return canSelect ? canSelect(radio) : true;
    }

    function syncTabindex() {
      radios.forEach(function (radio) {
        var checked = radio.getAttribute('aria-checked') === 'true';
        radio.setAttribute('tabindex', checked && selectable(radio) ? '0' : '-1');
      });
    }

    radios.forEach(function (radio, i) {
      radio.addEventListener('keydown', function (event) {
        var step = keys[event.key];
        if (!step) return;
        event.preventDefault();
        var next = null;
        for (var hop = 1; hop < radios.length; hop += 1) {
          var candidate = radios[(((i + step * hop) % radios.length) + radios.length) % radios.length];
          if (selectable(candidate)) {
            next = candidate;
            break;
          }
        }
        if (!next) return;
        onSelect(next);
        next.focus();
      });
    });

    syncTabindex();
    return syncTabindex;
  }

  function escapeHtml(value) {
    var span = document.createElement('span');
    span.textContent = value == null ? '' : String(value);
    return span.innerHTML;
  }

  function themeObj() {
    return window.theme || {};
  }

  function themeString(key, fallback) {
    var strings = themeObj().strings || {};
    return strings[key] || fallback;
  }

  function themeRoute(key, fallback) {
    var routes = themeObj().routes || {};
    return routes[key] || fallback;
  }

  function initBuybox(buybox) {
    var switchBtn = buybox.querySelector('.pdp-buybox__switch');
    var switchLabel = buybox.querySelector('.pdp-buybox__switch-label');
    var removeBtn = buybox.querySelector('.pdp-buybox__remove-btn');
    var intervalSegments = Array.prototype.slice.call(buybox.querySelectorAll('.pdp-buybox__interval-segment'));
    var planCards = Array.prototype.slice.call(buybox.querySelectorAll('.pdp-buybox__plan-card'));
    var planLabels = Array.prototype.slice.call(
      buybox.querySelectorAll('.pdp-buybox__price-increment[data-plan-index], .pdp-buybox__cta-label[data-plan-index]')
    );
    var form = buybox.querySelector('.pdp-buybox__form');
    var planLineInputs = form ? Array.prototype.slice.call(form.querySelectorAll('[data-plan-line]')) : [];
    var planIdInput = form ? form.querySelector('input[name="items[1][id]"]') : null;
    var selectedCard = null;
    var syncIntervalTabindex;
    var syncPlanTabindex;

    function currentInterval() {
      return buybox.getAttribute('data-interval-state');
    }

    function cardVariant(card, interval) {
      return card.getAttribute('data-variant-' + interval) || '';
    }

    /* A card is selectable when it is not disabled outright and maps a variant for the current
       interval (G21). */
    function isSelectable(card) {
      return !!card && !card.disabled && cardVariant(card, currentInterval()) !== '';
    }

    function syncAvailability() {
      planCards.forEach(function (card) {
        var selectable = isSelectable(card);
        card.classList.toggle('is-unavailable', !selectable);
        card.setAttribute('aria-disabled', selectable ? 'false' : 'true');
      });
    }

    /* Mirror the selection into the form: the plan line inputs are enabled only while a plan is
       selected in the ON state, so the same form serves the single-item add (G22 fall-through)
       and the two-line add. */
    function syncPlanLine() {
      var on = buybox.getAttribute('data-plan-state') === 'on';
      var variantId = on && selectedCard ? cardVariant(selectedCard, currentInterval()) : '';
      planLineInputs.forEach(function (input) {
        input.disabled = variantId === '';
      });
      if (planIdInput) planIdInput.value = variantId;
      buybox.setAttribute('data-plan-selected', variantId !== '' ? 'true' : 'false');
    }

    function selectPlan(card) {
      selectedCard = isSelectable(card) ? card : null;
      var index = selectedCard ? selectedCard.getAttribute('data-plan-index') : '';
      planCards.forEach(function (c) {
        var isSelected = c === selectedCard;
        c.classList.toggle('is-selected', isSelected);
        c.setAttribute('aria-checked', isSelected ? 'true' : 'false');
      });
      planLabels.forEach(function (label) {
        label.classList.toggle('is-current', index !== '' && label.getAttribute('data-plan-index') === index);
      });
      buybox.setAttribute('data-selected-plan-index', index);
      if (syncPlanTabindex) syncPlanTabindex();
      syncPlanLine();
    }

    function selectDefaultPlan() {
      var defaultIndex = parseInt(buybox.getAttribute('data-default-plan-index'), 10) || 0;
      var candidates = [planCards[defaultIndex]].concat(planCards).filter(isSelectable);
      selectPlan(candidates[0] || null);
    }

    function setPlanState(state) {
      buybox.setAttribute('data-plan-state', state);
      if (switchBtn) switchBtn.setAttribute('aria-checked', state === 'on' ? 'true' : 'false');
      syncPlanLine();
    }

    function setIntervalState(interval) {
      buybox.setAttribute('data-interval-state', interval);
      intervalSegments.forEach(function (segment) {
        var isSelected = segment.getAttribute('data-interval') === interval;
        segment.classList.toggle('is-selected', isSelected);
        segment.setAttribute('aria-checked', isSelected ? 'true' : 'false');
      });
      if (syncIntervalTabindex) syncIntervalTabindex();
      syncAvailability();
      if (isSelectable(selectedCard)) {
        selectPlan(selectedCard);
      } else {
        selectDefaultPlan();
      }
    }

    syncIntervalTabindex = initRadioGroup(intervalSegments, function (segment) {
      setIntervalState(segment.getAttribute('data-interval'));
    });
    syncPlanTabindex = initRadioGroup(planCards, selectPlan, isSelectable);

    if (switchBtn && switchLabel) {
      switchLabel.addEventListener('click', function () {
        switchBtn.click();
      });
    }

    /* Custom pixel event for measuring the subscription toggle; a custom pixel subscribed to
       `simo:pdp_plan_toggle` forwards it to GA4. No-op when the analytics object is absent. */
    function trackPlanToggle(state, control) {
      if (!window.Shopify || !Shopify.analytics || typeof Shopify.analytics.publish !== 'function') return;
      Shopify.analytics.publish('simo:pdp_plan_toggle', {
        state: state,
        control: control,
        product: buybox.getAttribute('data-product-handle') || ''
      });
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'pdp_plan_toggle', {
            send_to: 'G-D1E0Q6T55P',
            plan_state: state,
            plan_control: control,
            product_handle: buybox.getAttribute('data-product-handle') || ''
          });
        }
    }

    if (switchBtn) {
      switchBtn.addEventListener('click', function () {
        var next = buybox.getAttribute('data-plan-state') === 'on' ? 'default' : 'on';
        setPlanState(next);
        if (next === 'on') {
          setIntervalState('monthly');
          selectDefaultPlan();
        }
        trackPlanToggle(next === 'on' ? 'on' : 'off', 'switch');
      });
    }

    if (removeBtn) {
      removeBtn.addEventListener('click', function () {
        setPlanState('default');
        trackPlanToggle('off', 'remove');
      });
    }

    intervalSegments.forEach(function (segment) {
      segment.addEventListener('click', function () {
        setIntervalState(segment.getAttribute('data-interval'));
      });
    });

    planCards.forEach(function (card) {
      card.addEventListener('click', function () {
        if (!isSelectable(card)) return;
        selectPlan(card);
      });
    });

    syncAvailability();
    selectDefaultPlan();
    initVariantPicker(buybox, form);
    initQuantity(form);
    initCartForm(buybox, form);
  }

  /* Quantity stepper: sets `items[0][quantity]` (device) and mirrors it onto the plan line's
     `items[1][quantity]` so each device is added with its own plan. Typed values are clamped to a
     whole number of at least 1. */
  function initQuantity(form) {
    var wrapper = form ? form.querySelector('[data-pdp-quantity]') : null;
    if (!wrapper) return;
    var input = wrapper.querySelector('.pdp-buybox__quantity-input');
    var planQuantity = form.querySelector('[data-plan-quantity]');
    if (!input) return;

    function sync() {
      var value = parseInt(input.value, 10);
      if (isNaN(value) || value < 1) value = 1;
      input.value = value;
      if (planQuantity) planQuantity.value = value;
    }

    wrapper.querySelectorAll('[data-quantity-step]').forEach(function (button) {
      button.addEventListener('click', function () {
        var value = parseInt(input.value, 10) || 1;
        input.value = value + parseInt(button.getAttribute('data-quantity-step'), 10);
        sync();
      });
    });
    input.addEventListener('change', sync);
    form.addEventListener('submit', sync, true);
  }

  /* Variant picker (Ticket 17): only on buy boxes that render `.pdp-buybox__variant-picker`, so
     plan-card PDPs never enter here. The chosen option values resolve against the variants JSON the
     section embeds; the match is written to `items[0][id]`, the price row, the desktop title-block
     price, the CTA state and `?variant=` in the URL. No match leaves the CTA disabled with the
     unavailable note showing. */
  function initVariantPicker(buybox, form) {
    var picker = buybox.querySelector('.pdp-buybox__variant-picker');
    var dataEl = buybox.querySelector('script[data-pdp-variants]');
    if (!picker || !dataEl || !form) return;

    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    if (!variants || !variants.length) return;

    var idInput = form.querySelector('input[name="items[0][id]"]');
    var cta = form.querySelector('.pdp-buybox__cta');
    var ctaLabel = cta ? cta.querySelector('.pdp-buybox__cta-label') : null;
    var priceEl = buybox.querySelector('.pdp-buybox__price');
    var dataPanelHeadline = buybox.querySelector('[data-data-panel-headline]');
    var hero = buybox.closest('.pdp-hero');
    var infoPrice = hero ? hero.querySelector('.pdp-hero__info-price') : null;
    var infoPriceValue = infoPrice ? infoPrice.querySelector('[data-info-price]') : null;
    var infoWasPrice = infoPrice ? infoPrice.querySelector('[data-info-was-price]') : null;
    var equivalents = Array.prototype.slice.call((hero || buybox).querySelectorAll('[data-info-price-equivalent]'));
    var badges = Array.prototype.slice.call((hero || buybox).querySelectorAll('[data-promo-discount-badge]'));
    var unavailableNote = picker.querySelector('[data-variant-unavailable]');
    var groups = Array.prototype.slice.call(picker.querySelectorAll('.pdp-buybox__variant-option'));

    function groupValue(group) {
      var select = group.querySelector('select');
      if (select) return select.value;
      var checked = group.querySelector('.pdp-buybox__variant-choice.is-selected');
      return checked ? checked.getAttribute('data-value') : '';
    }

    function selectedOptions() {
      return groups.map(groupValue);
    }

    function findVariant(options) {
      for (var i = 0; i < variants.length; i += 1) {
        var match = true;
        for (var j = 0; j < options.length; j += 1) {
          if (variants[i].options[j] !== options[j]) {
            match = false;
            break;
          }
        }
        if (match) return variants[i];
      }
      return null;
    }

    function setCta(available, soldOut) {
      if (!cta) return;
      cta.disabled = !available;
      cta.setAttribute('aria-disabled', available ? 'false' : 'true');
      if (hero) hero.setAttribute('data-sold-out', !available && soldOut ? 'true' : 'false');
      if (ctaLabel) {
        ctaLabel.textContent = available
          ? cta.getAttribute('data-label-add') || ''
          : soldOut
            ? cta.getAttribute('data-label-sold-out') || ''
            : cta.getAttribute('data-label-add') || '';
      }
    }

    function syncUrl(variant) {
      if (!window.history || !window.history.replaceState) return;
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState(window.history.state, '', url.toString());
      } catch (e) {
        /* Older URL API: leave the address bar alone. */
      }
    }

    function apply() {
      var variant = findVariant(selectedOptions());
      if (unavailableNote) unavailableNote.hidden = !!variant;
      if (!variant) {
        setCta(false, false);
        return;
      }
      if (idInput) idInput.value = variant.id;
      /* Promo precedence, same as variant-price-block: a live promo strikes the regular price,
         otherwise a higher compare-at is struck. The section embeds the effective figures. */
      var promoPct = variant.promo_pct || 0;
      var struckShort = promoPct > 0 ? variant.price_short : variant.compare_short || '';
      if (priceEl) priceEl.textContent = variant.effective_formatted || variant.price_formatted;
      if (dataPanelHeadline && variant.included_data) dataPanelHeadline.textContent = variant.included_data;
      if (infoPriceValue) {
        infoPriceValue.textContent = variant.effective_short || variant.price_short;
      } else if (infoPrice) {
        infoPrice.textContent = variant.effective_short || variant.price_short;
      }
      if (infoWasPrice) {
        infoWasPrice.textContent = struckShort;
        infoWasPrice.hidden = struckShort === '';
      }
      badges.forEach(function (badge) {
        var badgeText = badge.querySelector('[data-promo-discount-badge-text]');
        var badgeSvg = badge.querySelector('svg');
        badge.hidden = promoPct <= 0;
        if (badgeText) badgeText.textContent = promoPct > 0 ? promoPct + '% Off' : '';
        if (badgeSvg) badgeSvg.setAttribute('aria-label', promoPct > 0 ? promoPct + '% off' : '');
      });
      /* Per-month equivalent of a prepaid variant ("($8.25/mo)"), embedded by the section. */
      var equivalent = variant.equivalent_short || '';
      equivalents.forEach(function (el) {
        el.textContent = equivalent === '' ? '' : '(' + equivalent + ')';
        el.hidden = equivalent === '';
      });
      setCta(variant.available, true);
      syncUrl(variant);
    }

    groups.forEach(function (group) {
      var select = group.querySelector('select');
      if (select) {
        select.addEventListener('change', apply);
        return;
      }
      var choices = Array.prototype.slice.call(group.querySelectorAll('.pdp-buybox__variant-choice'));
      var syncTabindex;
      function choose(choice) {
        choices.forEach(function (c) {
          var isSelected = c === choice;
          c.classList.toggle('is-selected', isSelected);
          c.setAttribute('aria-checked', isSelected ? 'true' : 'false');
        });
        if (syncTabindex) syncTabindex();
        apply();
      }
      syncTabindex = initRadioGroup(choices, choose);
      choices.forEach(function (choice) {
        choice.addEventListener('click', function () {
          choose(choice);
        });
      });
    });

    apply();
  }

  /* Atomic add (G22): one POST of the form's enabled inputs — `items[0]` device, `items[1]` plan —
     to cart/add.js. Shopify rejects the whole request when any line cannot be added, so a failure
     leaves the cart untouched and the message shows here. With `cart_type == go_to_cart` the form
     gets its action at submit time and Shopify lands on /cart with both lines (G23). The action is
     not in the markup because app embeds (Umbrella, bundles) inject into `form[action*="/cart/add"]`
     and Umbrella is ruled off the PDP (G05). */
  function initCartForm(buybox, form) {
    var cta = form ? form.querySelector('.pdp-buybox__cta') : null;
    var errorEl = form ? form.querySelector('.pdp-buybox__error') : null;
    var errorTimer;
    if (!form || !cta) return;

    function showError(message) {
      if (!errorEl) return;
      errorEl.textContent = message || errorEl.getAttribute('data-generic-error') || '';
      errorEl.style.display = 'block';
      clearTimeout(errorTimer);
      errorTimer = setTimeout(hideError, 8000);
    }

    function hideError() {
      if (!errorEl) return;
      errorEl.style.display = '';
      errorEl.textContent = '';
    }

    function restoreCta(originalHtml) {
      cta.classList.remove('is-adding', 'is-added');
      cta.innerHTML = originalHtml;
      cta.disabled = false;
    }

    /* Same source as theme.applyAjaxToProductForm (the /cart page's header icon), but only the
       count text is written: an app embed watches the header icon's subtree and reloads the page
       when its nodes are replaced. */
    function refreshHeaderCart() {
      var selector = '#site-control .cart:not(.nav-search)';
      fetch(themeRoute('cart_url', '/cart'), { credentials: 'same-origin' })
        .then(function (response) {
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelectorAll(selector);
          document.querySelectorAll(selector).forEach(function (el, i) {
            if (!fresh[i]) return;
            Array.prototype.forEach.call(fresh[i].children, function (freshChild, j) {
              var child = el.children[j];
              if (!child || child.tagName !== freshChild.tagName || freshChild.children.length) return;
              if (child.textContent !== freshChild.textContent) child.textContent = freshChild.textContent;
            });
          });
        })
        .catch(function () {});
    }

    /* Same markup as theme.applyAjaxToProductForm's "added to cart" modal, with one meta line
       per extra line item so the plan shows under the device. */
    function showAddedModal(items, noCheckoutButton) {
      var theme = themeObj();
      var device = items[0] || {};
      var imageUrl = device.image || '';
      if (imageUrl && theme.Shopify && typeof theme.Shopify.formatImage === 'function') {
        imageUrl = theme.Shopify.formatImage(imageUrl, '300x');
      }
      var meta = '';
      items.forEach(function (item, i) {
        var parts = [];
        if (i > 0) parts.push(item.product_title);
        (item.options_with_values || []).forEach(function (option) {
          if (option.name !== 'Title' && option.value !== 'Default Title') {
            parts.push(option.name + ': ' + option.value);
          }
        });
        if (parts.length) meta += '<p class="cart-product__content__meta">' + escapeHtml(parts.join(' — ')) + '</p>';
      });
      var offset = 25;
      try {
        var nav = theme.Nav();
        if (nav.bar.getPositionSetting() !== 'inline') offset = nav.bar.height();
      } catch (e) {
        offset = 25;
      }
      var tick = (theme.icons && theme.icons.tick) || '';
      window.showThemeModal(
        [
          '<div id="added-to-cart" class="theme-modal theme-modal--small" role="dialog" aria-modal="true" aria-labelledby="added-to-cart-title">',
          '<div class="inner" style="top:' + offset + 'px">',
          '<a href="#" data-modal-close class="modal-close">&times;</a>',
          '<h4 id="added-to-cart-title">' + tick + escapeHtml(themeString('productAddedToCart', 'Added to cart')) + '</h4>',
          '<div class="cart-product">',
          imageUrl ? '<div class="cart-product__image"><img src="' + escapeHtml(imageUrl) + '" alt="' + escapeHtml(device.featured_image && device.featured_image.alt) + '"/></div>' : '',
          '<div class="cart-product__content"><p class="cart-product__content__title">' + escapeHtml(device.product_title) + '</p>' + meta + '</div>',
          '</div>',
          '<p class="links ' + (noCheckoutButton ? 'links--no-checkout' : '') + '">',
          '<a href="' + escapeHtml(themeRoute('cart_url', '/cart')) + '" class="button ' + (noCheckoutButton ? '' : 'alt') + '">' + escapeHtml(themeString('viewCart', 'View cart')) + '</a>',
          noCheckoutButton ? '' : '<a href="' + escapeHtml(themeRoute('checkout', '/checkout')) + '" class="button button--checkout">' + escapeHtml(themeString('popupCheckout', 'Checkout')) + '</a>',
          '</p>',
          '</div>',
          '</div>',
        ].join(''),
        'added-to-cart',
        null
      );
    }

    function onAdded(data, originalHtml) {
      var items = data && data.items ? data.items : data ? [data] : [];
      var cartType = form.getAttribute('data-cart-type') || '';
      var tick = (themeObj().icons && themeObj().icons.tick) || '';
      cta.classList.remove('is-adding');
      cta.classList.add('is-added');
      cta.innerHTML = tick + ' ' + escapeHtml(themeString('productAddedToCart', 'Added to cart'));
      setTimeout(function () {
        restoreCta(originalHtml);
      }, 4000);

      if (cartType === 'add_and_redirect') {
        window.location = themeRoute('cart_url', '/cart');
        return;
      }
      if ((cartType === 'add_in_modal' || cartType === 'add_in_modal_no_checkout') && typeof window.showThemeModal === 'function') {
        showAddedModal(items, cartType === 'add_in_modal_no_checkout');
      }
      refreshHeaderCart();
    }

    form.addEventListener('submit', function (event) {
      var cartAddUrl = form.getAttribute('data-cart-add-url') || themeRoute('cart_add_url', '/cart/add');
      if (form.getAttribute('data-ajax') !== 'true') {
        form.action = cartAddUrl;
        return;
      }
      event.preventDefault();
      if (cta.disabled) return;
      var originalHtml = cta.innerHTML;
      hideError();
      cta.disabled = true;
      cta.classList.add('is-adding');
      cta.textContent = themeString('productAddingToCart', 'Adding');

      fetch(cartAddUrl + '.js', {
        method: 'POST',
        body: new FormData(form),
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      })
        .then(function (response) {
          return response
            .json()
            .catch(function () {
              return null;
            })
            .then(function (data) {
              return { ok: response.ok, data: data };
            });
        })
        .then(function (result) {
          if (!result.ok) throw result.data;
          onAdded(result.data, originalHtml);
        })
        .catch(function (error) {
          restoreCta(originalHtml);
          var message = error && (typeof error.description === 'string' ? error.description : error.message);
          showError(typeof message === 'string' ? message : '');
        });
    });
  }

  /* Stars → reviews (QA round 2, #21): the rating link scrolls to the reviews summary section
     (`#pdp-reviews-summary`), smoothly unless the visitor prefers reduced motion. The target's
     `scroll-margin-top` keeps it clear of the fixed header. Falls through to the native anchor
     jump when the section is not on the page. */
  function initReviewsLink(link) {
    link.addEventListener('click', function (event) {
      var target = document.querySelector(link.getAttribute('href'));
      if (!target) return;
      event.preventDefault();
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    });
  }

  /* Click-to-zoom (matches the live Showcase gallery): from 768px a click on an image opens the
     theme's fullscreen modal with every image stacked full size, scrolled to the clicked one.
     Reuses window.showThemeModal from theme.js so the close control, body lock and styling are
     the theme's own. */
  function initZoom(gallery, slides) {
    var zoomable = slides.filter(function (slide) { return slide.hasAttribute('data-full-size'); });
    if (!zoomable.length) return;
    zoomable.forEach(function (slide) {
      slide.addEventListener('click', function () {
        if (window.innerWidth < 768 || typeof window.showThemeModal !== 'function') return;
        var modal = document.createElement('div');
        modal.className = 'theme-modal theme-modal--fullscreen temp -light';
        modal.setAttribute('role', 'dialog');
        modal.setAttribute('aria-modal', 'true');
        var scroller = document.createElement('div');
        scroller.className = 'inner-scroller -out';
        var close = document.createElement('a');
        close.href = '#';
        close.className = 'modal-close';
        close.setAttribute('data-modal-close', '');
        close.innerHTML = '&times;';
        scroller.appendChild(close);
        var target = null;
        zoomable.forEach(function (item) {
          var img = document.createElement('img');
          img.className = 'zoom-image';
          img.src = item.getAttribute('data-full-size');
          var source = item.querySelector('img');
          if (source && source.alt) img.alt = source.alt;
          if (item === slide) { img.id = 'zoom-image'; target = img; }
          scroller.appendChild(img);
        });
        modal.appendChild(scroller);
        window.showThemeModal(modal, 'product-image', function () {
          setTimeout(function () {
            if (target) modal.scrollTop = target.offsetTop + target.offsetHeight / 2 - modal.clientHeight / 2;
            scroller.classList.remove('-out');
          }, 300);
        });
      });
    });
  }

  /* HELP-17494 sold-out alternatives. The cards are fetched once, the first time the section reads
     sold out (on load, or when the variant picker flips data-sold-out), from the
     pdp-sold-out-recommendations section. The block stays hidden when nothing in stock comes back.
     The row is native scroll-snap; the arrows step it one card at a time and the dots track the
     reachable positions. */
  function initRecs(recs) {
    var hero = recs.closest('.pdp-hero');
    var slot = recs.querySelector('[data-pdp-recs-slot]');
    var loaded = false;
    if (!hero || !slot) return;

    function load() {
      if (loaded || hero.getAttribute('data-sold-out') !== 'true') return;
      loaded = true;
      fetch(recs.getAttribute('data-url'))
        .then(function (response) {
          return response.ok ? response.text() : '';
        })
        .then(function (html) {
          var fragment = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
          if (!fragment || !fragment.querySelector('[data-pdp-recs-track]')) return;
          slot.innerHTML = fragment.innerHTML;
          /* The top-up can include this PDP's own product when another variant is in stock. */
          slot.querySelectorAll('[data-product-id="' + recs.getAttribute('data-product-id') + '"]').forEach(function (card) {
            card.closest('.pdp-recs__slide').remove();
          });
          if (!slot.querySelector('.pdp-recs__slide')) return;
          recs.hidden = false;
          initRecsCarousel(recs);
          if (window.jQuery && window.theme && typeof window.theme.applyAjaxToProductForm === 'function') {
            recs.querySelectorAll('[data-ajax-add-to-cart="true"]').forEach(function (wrapper) {
              window.theme.applyAjaxToProductForm(window.jQuery(wrapper));
            });
          }
        })
        .catch(function () {
          /* No picks is the same as an empty result: the block stays hidden. */
        });
    }

    new MutationObserver(load).observe(hero, { attributes: true, attributeFilter: ['data-sold-out'] });
    load();
  }

  function initRecsCarousel(recs) {
    var track = recs.querySelector('[data-pdp-recs-track]');
    var controls = recs.querySelector('.pdp-recs__controls');
    var prevBtn = recs.querySelector('[data-pdp-recs-prev]');
    var nextBtn = recs.querySelector('[data-pdp-recs-next]');
    var dotsWrap = recs.querySelector('[data-pdp-recs-dots]');
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var frame = 0;

    function step() {
      var slide = track.firstElementChild;
      var gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
      return slide ? slide.offsetWidth + gap : track.clientWidth;
    }

    function positions() {
      return Math.max(1, Math.ceil((track.scrollWidth - track.clientWidth - 1) / step()) + 1);
    }

    function current() {
      if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 1) return positions() - 1;
      return Math.round(track.scrollLeft / step());
    }

    function render() {
      var count = positions();
      var index = current();
      if (controls) controls.hidden = count <= 1;
      if (dotsWrap && dotsWrap.children.length !== count) {
        dotsWrap.innerHTML = '';
        for (var i = 0; i < count; i += 1) {
          var dot = document.createElement('span');
          dot.className = 'pdp-recs__dot';
          dotsWrap.appendChild(dot);
        }
      }
      if (dotsWrap) {
        Array.prototype.forEach.call(dotsWrap.children, function (dot, i) {
          dot.classList.toggle('is-active', i === index);
        });
      }
      if (prevBtn) prevBtn.disabled = index === 0;
      if (nextBtn) nextBtn.disabled = index >= count - 1;
    }

    function scrollByStep(direction) {
      track.scrollBy({ left: direction * step(), behavior: reduceMotion.matches ? 'auto' : 'smooth' });
    }

    function schedule() {
      if (frame) return;
      frame = window.requestAnimationFrame(function () {
        frame = 0;
        render();
      });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { scrollByStep(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollByStep(1); });
    track.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    render();
  }

  function init() {
    document.querySelectorAll('[data-pdp-recs]').forEach(initRecs);
    document.querySelectorAll('.pdp-hero__gallery').forEach(initGallery);
    document.querySelectorAll('.pdp-buybox').forEach(initBuybox);
    document.querySelectorAll('[data-scroll-to-reviews]').forEach(initReviewsLink);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
